<template>
  <modal-block modal-id="ModalPromo" close-button="yes">
    <template v-slot:content>
      <div class="contentBox">
        <promo-card v-if="activePromo" :promo="activePromo" compact />
      </div>
    </template>
  </modal-block>
</template>

<script>
import ModalBlock from '@/components/ModalBlock'
import PromoCard from '@/components/PromoCard'
import promotionsData from '@/data/promotions.json'

export default {
  name: 'ModalPromo',
  components: { ModalBlock, PromoCard },
  computed: {
    activePromo() {
      const id = this.$store.state.activePromoId
      if (!id) return null
      return promotionsData.promotions.find(p => p.id === id) || null
    },
  },
}
</script>

<style>
  #ModalPromo{max-width: 650px; width: 100%;}
  #ModalPromo.mobile{width: 100%; height: 100%}
  #ModalPromo>.contentBox{overflow-y: auto}
</style>
